export const ProductUtils = {
  methods: {
    shortDescription: function (fullDescription) {
      var shortDescription = null

      if (fullDescription != null) {
        if (fullDescription.indexOf('|') > -1) {
          shortDescription = fullDescription.substring(0, fullDescription.indexOf('|')).trim()
        } else {
          shortDescription = fullDescription.trim()
        }
      }

      return shortDescription
    },
    longDescription: function (fullDescription) {
      var longDescription = null

      if (fullDescription != null) {
        if (fullDescription.indexOf('|') > -1) {
          longDescription = fullDescription.substring(fullDescription.indexOf('|') + 1).trim()
        } else {
          longDescription = null
        }
      }

      return longDescription
    },
    attributeHeadline: function (attributeName) {
      var self = this
      var attrObject = {}

      if (typeof attributeName === 'string') {
        if (attributeName.indexOf('|') > -1) {
          attrObject.value = attributeName.substring(0, attributeName.indexOf('|')).trim()
        } else {
          attrObject.value = attributeName.trim()
        }
      } else {
        attrObject.value = attributeName
      }

      // Remove any values in brackets from display
      attrObject.value = attrObject.value ? attrObject.value.toString().replace(/\[.*\]/g, '') : null

      return attrObject.value
    },
    attributeSubHeadline: function (attributeName) {
      var self = this
      var attrObject = {}

      if (typeof attributeName === 'string') {
        if (attributeName.indexOf('|') > -1) {
          attrObject.value = attributeName.substring(attributeName.indexOf('|') + 1).trim()
        } else {
          attrObject.value = attributeName.trim()
        }

        var hasTwoAsterisks = (attrObject.value.match(/.*/gi).length = 2)
        if (hasTwoAsterisks) {
          attrObject.value = attrObject.value.replace(/\*([^*]+)\*/g, '<em>$1</em>')
        }
      } else {
        attrObject.value = attributeName
      }

      // Remove any values in brackets from display
      attrObject.value = attrObject.value ? attrObject.value.replace(/\[.*\]/g, '') : null

      return attrObject.value
    },
  },
}
